import { render } from "./SingleNotification.vue?vue&type=template&id=88f1cff6"
import script from "./SingleNotification.vue?vue&type=script&lang=js"
export * from "./SingleNotification.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__